import React from "react";
import { Stack, Box } from "@mui/material";
import { connect } from "react-redux";

import { HubToolbar } from "../../components";
import { getIsDialogOpen, getUserLocation, setIsOpenDialog } from "../../redux";

import { StyledDrawer } from "./styles";
import ManageMoldForm from "./ManageMoldForm";

const ManageMold = ({ partId, locationId = 1, _onClose = () => {} }) => {
  return (
    <StyledDrawer anchor="right" open={partId} onClose={_onClose}>
      <Stack overflow="hidden">
        <HubToolbar
          label="Manage Part Mold"
          onClose={_onClose}
          direction="left"
        />
        <Box
          sx={{
            height: "100%",
            overflowY: "auto",
            padding: "0 0 25px 0",
            "&::-webkit-scrollbar": { display: "none !important" },
          }}
        >
          <Stack padding="25px" gap="25px" width="100%">
            <ManageMoldForm
              partId={partId}
              locationId={locationId}
              onClose={_onClose}
            />
          </Stack>
        </Box>
      </Stack>
    </StyledDrawer>
  );
};

const mapStateToProps = (state) => ({
  partId: getIsDialogOpen(state, "manage-mold"),
  locationId: getUserLocation(state),
});
const mapDispatchToProps = {
  _onClose: () => setIsOpenDialog("manage-mold", false),
};
export const ManageMoldDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageMold);
